import React, { useEffect, useRef, useState } from "react";
import styles from "./MainPiecesBox.module.css";

export default function MainPiecesBox({
  id,
  src,
  svg,
  top,
  right,
  opacity,
  visibility,
  isSelect = false,
  clN,
  animIndex,
  setAnimIndex,
  termsIndex,
}) {
  const [isInView, setIsInView] = useState(false);
  const [isOnJaygah1, setIsOnJaygah1] = useState(false);
  const [isOnJaygah2, setIsOnJaygah2] = useState(false);
  const [isOnJaygah3, setIsOnJaygah3] = useState(false);
  const [isOnJaygah4, setIsOnJaygah4] = useState(false);
  const [isOnJaygah5, setIsOnJaygah5] = useState(false);
  const [isOnJaygah6, setIsOnJaygah6] = useState(false);
  const [isOnJaygah7, setIsOnJaygah7] = useState(false);
  const [isOnJaygah8, setIsOnJaygah8] = useState(false);
  const sectionRef = useRef([]);
  


  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           // Section is in view

  //           globalContextData.setIsHeaderShown(true)
  //         } else {
  //           // Section is out of view
  //           setIsInView(false);

  //         }
  //       });
  //     },
  //     { threshold: 0.5 } // Adjust the threshold as needed
  //   );

  //   if (sectionRef.current) {
  //     observer.observe(sectionRef.current);
  //   }

  //   return () => {
  //     if (sectionRef.current) {
  //       observer.unobserve(sectionRef.current);
  //     }
  //   };
  // }, []);

  const useResizeObserver = (elementId, callback) => {
    const elementRef = useRef(null);

    useEffect(() => {
      const element = document.getElementById(elementId);
      elementRef.current = element;

      const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          const { width, height } = entry.contentRect;
          callback(width, height);
        });
      });

      if (elementRef.current) {
        observer.observe(elementRef.current);
      }

      return () => {
        if (elementRef.current) {
          observer.unobserve(elementRef.current);
        }
      };
    }, [elementId, callback]);

    return elementRef;
  };
  const elementRef = useResizeObserver("1", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(1);
      setIsOnJaygah1(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah1(false);
    }
  });
  const elementRef2 = useResizeObserver("2", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(2);
      setIsOnJaygah2(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah2(false);
    }
  });
  const elementRef3 = useResizeObserver("3", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(3);
      setIsOnJaygah3(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah3(false);
    }
  });
  const elementRef4 = useResizeObserver("4", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(4);
      setIsOnJaygah4(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah4(false);
    }
  });
  const elementRef5 = useResizeObserver("5", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(5);
      setIsOnJaygah5(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah5(false);
    }
  });
  const elementRef6 = useResizeObserver("6", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(6);
      setIsOnJaygah6(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah6(false);
    }
  });
  const elementRef7 = useResizeObserver("7", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(7);
      setIsOnJaygah7(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah7(false);
    }
  });
  const elementRef8 = useResizeObserver("8", (width, height) => {
    // Handle the width and height changes here
    if (width == 67) {
      setAnimIndex(8);
      setIsOnJaygah8(true);
      stopAnims();
      setTimeout(() => {
        runAnims();
      }, 3500);
    } else if (width < 66.4) {
      setIsOnJaygah8(false);
      if (animIndex == 8) {
        setAnimIndex(0);
      }
    }
  });

  const stopAnims = () => {
    const item1 = document.getElementById("1");
    const item2 = document.getElementById("2");
    const item3 = document.getElementById("3");
    const item4 = document.getElementById("4");
    const item5 = document.getElementById("5");
    const item6 = document.getElementById("6");
    const item7 = document.getElementById("7");
    const item8 = document.getElementById("8");
    item1.classList.add(`${styles.hovered}`);
    item2.classList.add(`${styles.hovered}`);
    item3.classList.add(`${styles.hovered}`);
    item4.classList.add(`${styles.hovered}`);
    item5.classList.add(`${styles.hovered}`);
    item6.classList.add(`${styles.hovered}`);
    item7.classList.add(`${styles.hovered}`);
    item8.classList.add(`${styles.hovered}`);
  };
  const runAnims = () => {
    const item1 = document.getElementById("1");
    const item2 = document.getElementById("2");
    const item3 = document.getElementById("3");
    const item4 = document.getElementById("4");
    const item5 = document.getElementById("5");
    const item6 = document.getElementById("6");
    const item7 = document.getElementById("7");
    const item8 = document.getElementById("8");
    item1.classList.remove(`${styles.hovered}`);
    item2.classList.remove(`${styles.hovered}`);
    item3.classList.remove(`${styles.hovered}`);
    item4.classList.remove(`${styles.hovered}`);
    item5.classList.remove(`${styles.hovered}`);
    item6.classList.remove(`${styles.hovered}`);
    item7.classList.remove(`${styles.hovered}`);
    item8.classList.remove(`${styles.hovered}`);
  };

  const addHover = () => {
    const item1 = document.getElementById("1");
    const item2 = document.getElementById("2");
    const item3 = document.getElementById("3");
    const item4 = document.getElementById("4");
    const item5 = document.getElementById("5");
    const item6 = document.getElementById("6");
    const item7 = document.getElementById("7");
    const item8 = document.getElementById("8");
    if (
      isOnJaygah1 ||
      isOnJaygah2 ||
      isOnJaygah3 ||
      isOnJaygah4 ||
      isOnJaygah5 ||
      isOnJaygah6 ||
      isOnJaygah7 ||
      isOnJaygah8
    ) {
      item1.classList.add(`${styles.hovered}`);
      item2.classList.add(`${styles.hovered}`);
      item3.classList.add(`${styles.hovered}`);
      item4.classList.add(`${styles.hovered}`);
      item5.classList.add(`${styles.hovered}`);
      item6.classList.add(`${styles.hovered}`);
      item7.classList.add(`${styles.hovered}`);
      item8.classList.add(`${styles.hovered}`);
    }
  };
  const clearHover = () => {
    const item1 = document.getElementById("1");
    const item2 = document.getElementById("2");
    const item3 = document.getElementById("3");
    const item4 = document.getElementById("4");
    const item5 = document.getElementById("5");
    const item6 = document.getElementById("6");
    const item7 = document.getElementById("7");
    const item8 = document.getElementById("8");

    item1.classList.remove(`${styles.hovered}`);
    item2.classList.remove(`${styles.hovered}`);
    item3.classList.remove(`${styles.hovered}`);
    item4.classList.remove(`${styles.hovered}`);
    item5.classList.remove(`${styles.hovered}`);
    item6.classList.remove(`${styles.hovered}`);
    item7.classList.remove(`${styles.hovered}`);
    item8.classList.remove(`${styles.hovered}`);
  };
  useEffect(() => {
    if (termsIndex != 0) {
      // sectionRef.current.classList.remove(`${styles[clN]}`);
      // void sectionRef.current.offsetWidth;
      // sectionRef.current.classList.add(`${styles[clN]}`);
    
    }
  }, [termsIndex]);

  return (
    <>
      <div
        ref={sectionRef}
        id={id}
        data-item-id={id}
        style={{
          top: `${top}px`,
          right: `${right}px`,
          opacity: opacity,
          visibility: visibility,
        }}
        className={`absolute w-[65px] h-[63px] ${
          isSelect
            ? "rounded-[15px] bg-[#fec62b8e] scale-125"
            : "rounded-[40px] bg-[#E5E5E5]"
        }  flex items-center justify-center  cursor-pointer ${styles[clN]} `}
        onMouseMove={addHover}
        onMouseOut={clearHover}
      >
        <div className="w-[65px] h-[63px] flex items-center justify-center p-[8px]">
          <img id={id} src={src} className="" />
        </div>
      </div>
    </>
  );
}
